/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { Dropdown1 } from '../../../../_metronic/partials'

type Props = {
  className: string
  items?: number
}

const Oparators: React.FC<Props> = ({className, items = 6}) => {
  const [oparators, setOparators] = React.useState<any[]>([
    {
      id: 1,
      name: 'STC',
      logo: toAbsoluteUrl('/media/svg/brand-logos/stc.svg'),
      status: 'success',
      progress: 100,
    },
    {
      id: 2,
      name: 'Mobily',
      logo: toAbsoluteUrl('/media/svg/brand-logos/mobily.svg'),
      status: 'success',
      progress: 100,
    },
    {
      id: 3,
      name: 'Virgin mobile KSA	',
      logo: toAbsoluteUrl('/media/svg/brand-logos/virgin.svg'),
      status: 'success',
      progress: 100,
    },
    
    {
      id: 4,
      name: 'Orange',
      logo: toAbsoluteUrl('/media/svg/brand-logos/orange.svg'),
      status: 'success',
      progress: 100,
    },
    {
      id: 5,
      name: 'Zain',
      logo: toAbsoluteUrl('/media/svg/brand-logos/zain.svg'),
      status: 'success',
      progress: 100,
    },
    {
      id: 6,
      name: 'etisalat',
      logo: toAbsoluteUrl('/media/svg/brand-logos/etisalat.svg'),
      status: 'success',
      progress: 100,
    },



  ])
  return (
    <div className='card card-xl-stretch mb-xl-8'>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark'>Oparators</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>Sorted by users count</span>
        </h3>
        <div className='card-toolbar'>
          {/* begin::Menu */}
          <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
          </button>
          <Dropdown1 />
          {/* end::Menu */}
        </div>
      </div>
      
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-5'>
        {/* begin::Item */}
        {
          oparators.map(company => (
            <div className='d-flex align-items-sm-center mb-7'>
          {/* begin::Symbol */}
          <div className='symbol symbol-50px me-5'>
            <span className='symbol-label'>
              <img
                src={toAbsoluteUrl(company.logo)}
                className='h-50 w-50 align-self-center'
                alt=''
              />
            </span>
          </div>
          {/* end::Symbol */}
          {/* begin::Section */}
          <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
            <div className='flex-grow-1 me-2'>
              <a href='#' className='text-gray-800 text-hover-primary fs-6 fw-bold'>
                {company.name}
              </a>
              <span className='text-muted fw-semibold d-block fs-7'>Mark, Rowling, Esther</span>
            </div>
            <span className='badge badge-light fw-bold my-2'>+82$</span>
          </div>
          {/* end::Section */}
        </div>
          ))
        }
       
      </div>
      {/* end::Body */}
    </div>
  )
}

export {Oparators}
